module.exports = __webpack_public_path__ + "static/img/bus-1.d47ab2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-1.jpg
// module id = BD03
// module chunks = 0